import React from 'react';
import SportPlaceholder from '../../../ContentLoader/SportPlaceholder/SportPlaceholder';
import styles from './Placeholder.module.scss';
import { SPORTS_TYPES_DIRECTION } from '../../../../../constants/defaultValues';

const Placeholder = ({ count, direction }) => {
    return (
        <div
            className={`${
                direction === SPORTS_TYPES_DIRECTION.horizontal ? styles.horizontal : ''
            } ${styles.placeholderContainer}`}
        >
            {Array(count)
                .fill('')
                .map((e, i) => {
                    const key = `${i}-${new Date().getTime()}`;

                    return <SportPlaceholder key={key} />;
                })}
        </div>
    );
};

export default Placeholder;
